export class ErrorMessage {
  status: number;
  statustext: string;
  message: string;

  public constructor(status: number, statustext: string, message: string) {
    this.status = status;
    this.statustext = statustext;
    this.message = message;
  }
}
